import React, { useEffect, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import ReciboPagamentoMedico from '.';
import { useToast } from '../../../../hooks/toast';
import api from '../../../../services/api';
import getResponseErrors from '../../../../utils/getResponseErrors';
import { IPagamentosMedicosBase } from '../DespesasPagamentoMedico';

// import { Container } from './styles';
interface IUrlParams {
  id: string;
}
const ReciboImpressao: React.FC = () => {
  const { params } = useRouteMatch<IUrlParams>();
  const { id } = params;

  const { addToast } = useToast();

  const [recibo, setRecido] = useState<IPagamentosMedicosBase>();

  useEffect(() => {
    async function loadDados(): Promise<void> {
      try {
        const response = await api.get<IPagamentosMedicosBase>(
          `/pagamentosmedicos/${id}`,
        );

        setRecido(response.data);
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível carregar dados',
          type: 'error',
          description: mensagemErro,
        });
      }
    }
    loadDados();
  }, [id, addToast]);
  return (
    <>
      {recibo && <ReciboPagamentoMedico recibo={recibo.recibo} />}
      {!recibo && <h2>Carregando...</h2>}
      <div />
    </>
  );
};

export default ReciboImpressao;
